import { MapPin, Phone, Clock } from "lucide-react";
import usePageMeta from "@/hooks/usePageMeta";
import Reveal from "@/components/Reveal";
import QuoteForm from "@/components/QuoteForm";
import { BUSINESS, HOURS } from "@/data/content";

const Contact = () => {
  usePageMeta(
    "Contact & Book — Luxpress Detailing, South Melbourne",
    "Request a quote or book a detail at 476 City Road, South Melbourne. Open daily 9:30 AM – 6:00 PM. Call 0432 001 068."
  );
  return (
    <div className="mx-auto max-w-7xl px-5 pb-24 pt-36 sm:px-8 sm:pt-44" data-testid="contact-page">
      <Reveal>
        <p className="kicker">Contact & book</p>
        <h1 className="mt-4 max-w-3xl font-display text-4xl font-black uppercase leading-[0.95] tracking-tighter sm:text-6xl">
          Tell us about<br /><span className="text-mint">the car.</span>
        </h1>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-chrome">
          Select a service and the form carries it through. Attach a photo if it helps.
          We reply within business hours — or call and talk to a person now.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-12 lg:grid-cols-[1.2fr_1fr]">
        <Reveal><QuoteForm /></Reveal>

        <div className="space-y-10">
          <Reveal delay={0.1}>
            <div className="border border-teal-line bg-panel p-8">
              <div className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-mint" aria-hidden="true" />
                <p className="spec-label">Call the studio</p>
              </div>
              <a href={BUSINESS.phoneHref} data-testid="contact-phone-link" className="mt-3 block font-display text-3xl font-bold tracking-tight text-white transition-colors duration-200 hover:text-mint">
                {BUSINESS.phoneDisplay}
              </a>
              <div className="mt-8 flex items-center gap-3">
                <MapPin className="h-4 w-4 text-mint" aria-hidden="true" />
                <p className="spec-label">Find us</p>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-white/90" data-testid="contact-address">{BUSINESS.address}</p>
              <p className="mt-2 text-sm text-chrome">
                Serving {BUSINESS.areas.join(", ")}.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="border border-teal-line bg-panel p-8">
              <div className="flex items-center gap-3">
                <Clock className="h-4 w-4 text-mint" aria-hidden="true" />
                <p className="spec-label">Hours — open daily</p>
              </div>
              <ul className="mt-4 space-y-2" data-testid="contact-hours">
                {HOURS.map((h) => (
                  <li key={h.day} className="flex justify-between border-b border-teal-line pb-2 font-mono text-xs last:border-0">
                    <span className="uppercase tracking-[0.15em] text-chrome">{h.day}</span>
                    <span className="text-white">{h.time}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <iframe
              title="Map — Luxpress Detailing, 476 City Road, South Melbourne VIC 3205"
              data-testid="contact-map"
              src="https://www.google.com/maps?q=476+City+Road,+South+Melbourne+VIC+3205,+Australia&output=embed"
              className="aspect-[4/3] w-full border border-teal-line grayscale invert-[0.92] hue-rotate-180"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </Reveal>
        </div>
      </div>
    </div>
  );
};

export default Contact;
